import { render, staticRenderFns } from "./InfoPriceProductModal.vue?vue&type=template&id=51a48806&scoped=true&"
import script from "./InfoPriceProductModal.vue?vue&type=script&lang=js&"
export * from "./InfoPriceProductModal.vue?vue&type=script&lang=js&"
import style0 from "./InfoPriceProductModal.vue?vue&type=style&index=0&id=51a48806&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a48806",
  null
  
)

export default component.exports